import BaseModel from '../base/BaseModel.model';
import PorposalBudgetSubItem from './porposalBudgetSubItem.model';
import ProposalBudgetSubItemExecutionDocument from './proposalBudgetSubItemExecutionDocument.model';
import BudgetSubItemEvaluation from './budgetSubItemEvaluation.model';
export default class ProposalBudgetSubItemExecution extends BaseModel {

    public isApproved: boolean = false;

    public porposalBudgetSubItemId?: number | null;
    public porposalBudgetSubItem?: PorposalBudgetSubItem | null;
    public proposalBudgetItemExecutionId?: number | null;
    public amountSpent?: number | null;
    public totalAmountAccumulatedAbove?: number | null;
    public concept?: string | null;
    public proposalBudgetSubItemExecutionDocuments: Array<ProposalBudgetSubItemExecutionDocument> = [];
    public files = [];

    // UI
    public budgetSubItemEvaluationUI: BudgetSubItemEvaluation = new BudgetSubItemEvaluation();

    constructor() {
        super();
        this.init();
    }

    init() {
        this.porposalBudgetSubItemId = null;
        this.porposalBudgetSubItem = null;
        this.proposalBudgetItemExecutionId = null;

        this.amountSpent = 0;
        this.totalAmountAccumulatedAbove = null;
        this.concept = null;
        this.isApproved = true;

        this.proposalBudgetSubItemExecutionDocuments = [];
        this.files = [];
        this.budgetSubItemEvaluationUI = new BudgetSubItemEvaluation();
    }
}